/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsListJobs } from "../../funcs/computeJobsListJobs.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListJobsRequest$inboundSchema,
};

export const tool$computeJobsListJobs: ToolDefinition<typeof args> = {
  name: "compute-jobs-list-jobs",
  description: `List jobs`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsListJobs(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
